import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'doge',
  templateUrl: './doge.component.html',
  styleUrls: ['./doge.component.scss']
})
export class Doge_Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
